import React from 'react';

export default function dynamic(importFn: () => Promise<any>, options?: any) {
  const normalizedImportFn = () =>
    importFn().then((resolved) =>
      resolved && typeof resolved === 'object' && 'default' in resolved
        ? resolved
        : { default: resolved },
    );
  const LazyComponent = React.lazy(normalizedImportFn);
  return function DynamicWrapper(props: any) {
    const Fallback = options?.loading || (() => null);
    return (
      <React.Suspense fallback={<Fallback />}>
        <LazyComponent {...props} />
      </React.Suspense>
    );
  };
}

export { dynamic };
